import React from 'react';
import { BillableLeadsReport } from './reports/ReportComponents';

export default function ReportBillableClient() {
  return (
    <div style={{ maxWidth: '1600px' }}>
      <h2 style={{ margin: '0 0 20px' }}>Billable Leads by Client</h2>
      <BillableLeadsReport groupBy="client" />
    </div>
  );
}
